export class Payment{
    constructor(
        public orderId: string,
        public razorpayPaymentId: string,
        public amount: number
    ) { }
}